import { API_ENDPOINTS } from '../endpoints';

export const getAdminMarkets = async (protectedClient) => {
    const response = await protectedClient.get(API_ENDPOINTS.ADMIN_MARKET);
    return response.data.data;
};

export const updateProductInMarket = async (protectedClient, marketId, product) => {
    const response = await protectedClient.put(API_ENDPOINTS.ADMIN_MARKET_PRODUCT, {marketId, product});
    return response.data;
};

export const updateMarketStatus = async (protectedClient, marketId, isOpen, openingMode) => {
    const response = await protectedClient.put(API_ENDPOINTS.ADMIN_MARKET, {marketId, isOpen, openingMode});
    return response.data;
};